module.exports = __webpack_public_path__ + "img/hys-5.80496715.jpg";